import axios from "axios";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.mrbikedoctor.cloud/bikedoctor";

export const getAuthToken = () => localStorage.getItem("adminToken");

// Shared request helper for every Preferences module (Campaigns, Promo
// Codes, Rewards & Referral rules, Legal, App Content). Promo Codes is fully
// wired to real backend routes (/preferences/promo-codes/*) as of the Phase 1
// promo-code module; the other modules under this client may still be ahead
// of their backend routes and will surface via each page's error state until
// implemented server-side.
export const prefApiRequest = async (method, endpoint, data, isFormData = false) => {
  const headers = {};
  const token = getAuthToken();
  if (token) headers.token = token;
  if (isFormData) headers["Content-Type"] = "multipart/form-data";

  const response = await axios({
    method,
    url: `${API_BASE_URL}${endpoint}`,
    data,
    headers,
    withCredentials: true,
  });
  return response.data;
};
